import OrderReviewContact from "./OrderReviewContact.vue";

export {OrderReviewContact}
export default OrderReviewContact
